import axios from 'axios'
import {apiBaseUrl} from '@/config/config'
// 创建axios实例
const service = axios.create({
  baseURL: apiBaseUrl, // api的base_url
  timeout: 20000 // 请求超时时间
})

export default service
